module.exports = __webpack_public_path__ + "static/media/PHONE-MOCKUP-1.065335ec.png";